exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".igo-panel-header{height:46px;padding:3px;text-align:center}.igo-panel-header h3{margin:0;height:40px}.igo-panel-header>>>[panelleftbutton]{float:left}.igo-panel-header>>>[panelrightbutton]{float:right}.igo-panel-content{height:calc(100% - 46px);overflow:auto}.igo-panel-title{display:block;width:calc(100% - 80px);height:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;line-height:40px;float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/shared/panel/panel.component.styl
// module id = 861
// module chunks = 0